"use client";

import { createContext, useContext } from "react";

export type EnquirySuccessPrimaryRedirect = "close" | "dashboard" | "my-enquiries";

export interface EnquirySuccessConfig {
  title: string;
  subheading: string;
  /** Primary button label (default "Back to Home") */
  primaryButtonLabel?: string;
  /** Where the primary button navigates (default "close" = just close modal) */
  primaryButtonRedirect?: EnquirySuccessPrimaryRedirect;
  extraButton?: boolean;
  extraButtonLabel?: string;
}

export const EnquiryModalDropdownContext = createContext<{
  setPropertyDropdownOpen: (open: boolean, suggestionCount?: number) => void;
  setDateTimeVisible: (visible: boolean) => void;
  isSubmitting: boolean;
  setIsSubmitting: (value: boolean) => void;
  successConfig: EnquirySuccessConfig | null;
  preselectedListingId: string | null;
  preselectedListingState: string | null;
  setSuccessConfig: (config: EnquirySuccessConfig | null) => void;
}>({
  setPropertyDropdownOpen: () => {},
  setDateTimeVisible: () => {},
  isSubmitting: false,
  setIsSubmitting: () => {},
  preselectedListingId: null,
  preselectedListingState: null,
  successConfig: null,
  setSuccessConfig: () => {},
});

export function useEnquiryModalDropdown() {
  return useContext(EnquiryModalDropdownContext);
}
